export default __webpack_public_path__ + "static/media/SmallSBExcessiveMovementEdited.750770ab.png";